import { DatabaseRecord } from "../repos/table.repo";

export interface WaterSupplySuspensionModel extends DatabaseRecord {
    name: string;
    status: string;
    waterFactoryId: string;
    reason: string;
    createdBy: string;
    createdAt?: Date
    updatedBy: string;
    updatedAt?: Date
}

export class WaterSupplySuspensionModelFactory {
    static getEmpty(): WaterSupplySuspensionModel {
        return {
            id: "",
            name: "",
            status: "",
            waterFactoryId: "",
            reason: "",
            createdBy: "",
            updatedBy: ""
        };
    }
}